import React, { useCallback, useState, useMemo } from 'react';
import { useDerivedState } from 'huse';
import { Dropdown, Button, Checkbox, Menu, Gap } from '@osui/ui'; // TODO: OSUI导出DropdownProps

import classNames from 'classnames';
import './index.less';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const IconSetting = props => /*#__PURE__*/_jsx("svg", {
  width: 16,
  height: 16,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    // eslint-disable-next-line max-len
    d: "M11.5 2 15 8.063l-3.5 6.062h-7L1 8.063 4.5 2h7Zm-.578 1H5.077L2.155 8.064l2.922 5.06h5.845l2.924-5.06L10.922 3ZM8 6.064a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm0 1a1.001 1.001 0 0 0 0 2 1.001 1.001 0 0 0 0-2Z",
    fillRule: "evenodd"
  })
});

const clsPrefix = 'icloud-ui-dropdown-select';

const renderItems = (options, selectedKeys) => {
  return options === null || options === void 0 ? void 0 : options.map(item => {
    const isSelected = selectedKeys.includes(item === null || item === void 0 ? void 0 : item.value.toString());
    return /*#__PURE__*/_jsxs(Menu.Item, {
      className: classNames(`${clsPrefix}-menu-item`, {
        [`${clsPrefix}-menu-item-selected`]: isSelected
      }),
      disabled: (item === null || item === void 0 ? void 0 : item.disabled) || (item === null || item === void 0 ? void 0 : item.isChoose),
      children: [/*#__PURE__*/_jsx(Checkbox, {
        disabled: (item === null || item === void 0 ? void 0 : item.disabled) || (item === null || item === void 0 ? void 0 : item.isChoose),
        checked: isSelected
      }), /*#__PURE__*/_jsx(Gap.Horizontal, {
        factor: 2,
        base: 4
      }), /*#__PURE__*/_jsx("span", {
        className: `${clsPrefix}-menu-text`,
        children: item === null || item === void 0 ? void 0 : item.label
      })]
    }, item === null || item === void 0 ? void 0 : item.value);
  });
};

const DropdownSelect = props => {
  const {
    value = [],
    onChange,
    options,
    trigger = ['click'],
    menuProps,
    ...dropdownProps
  } = props; // Handle visible 确保不会自动关闭，点击外面的时候才关闭

  const [visible, setVisible] = useState(false);
  const handleVisibleChange = useCallback(flag => {
    setVisible(flag);
  }, []); // === Handle selected keys ===

  const onMenuSelect = menuProps === null || menuProps === void 0 ? void 0 : menuProps.onSelect;
  const onMenuDeselect = menuProps === null || menuProps === void 0 ? void 0 : menuProps.onDeselect;
  const propSelectedKeys = value;
  const mergedSelectedKeys = useMemo(() => {
    const chooseValue = options.filter(item => item.isChoose).map(item => item.value.toString());
    return Array.from(new Set([...propSelectedKeys, ...chooseValue]));
  }, [propSelectedKeys, options]);
  const [innerSelectedKeys, setInnerSelectedKeys] = useDerivedState(mergedSelectedKeys);
  const handleSelect = useCallback(args => {
    const {
      selectedKeys
    } = args;
    setInnerSelectedKeys(selectedKeys);
    onMenuSelect && onMenuSelect(args);
    onChange(selectedKeys);
  }, [onMenuSelect, setInnerSelectedKeys, onChange]);
  const handleDeselect = useCallback(args => {
    const {
      selectedKeys
    } = args;
    setInnerSelectedKeys(selectedKeys);
    onMenuDeselect && onMenuDeselect(args);
    onChange(selectedKeys);
  }, [onMenuDeselect, setInnerSelectedKeys, onChange]);

  const menu =
  /*#__PURE__*/

  /* eslint-disable-next-line react/jsx-no-bind */
  _jsx("div", {
    className: `${clsPrefix}-dropdown-menu-wrapper`,
    onClick: e => e.stopPropagation(),
    children: /*#__PURE__*/_jsx(Menu, { ...menuProps,
      selectable: true,
      multiple: true,
      selectedKeys: innerSelectedKeys,
      onSelect: handleSelect,
      onDeselect: handleDeselect,
      children: renderItems(options, innerSelectedKeys)
    })
  });

  return /*#__PURE__*/_jsx("div", {
    className: clsPrefix,
    children: /*#__PURE__*/_jsx(Dropdown, { ...dropdownProps,
      overlay: menu,
      trigger: trigger,
      onVisibleChange: handleVisibleChange,
      visible: visible,
      children: /*#__PURE__*/_jsx(Button, {
        className: `${clsPrefix}-trigger-button`,
        icon: /*#__PURE__*/_jsx(IconSetting, {})
      })
    })
  });
};

export default DropdownSelect;
//# sourceMappingURL=es/index.js.map